import { Link } from "react-router-dom";
import "../css/service.css";

const groups = [
  {
    number: "01",
    name: "Business Stationery",
    description:
      "Professional printed materials that keep your business looking consistent and credible.",
    imageClass: "stationery-image",
    items: [
      {
        item: "Letterheads",
        detail:
          "Premium business letterheads printed with sharp text and accurate brand colours.",
      },
      {
        item: "Business Cards",
        detail:
          "Professional cards with premium paper, finishes and custom sizing options.",
      },
      {
        item: "Invoice Books",
        detail:
          "Carbonless duplicate and triplicate books with numbering and perforation.",
      },
      {
        item: "Envelopes",
        detail:
          "Branded envelopes designed for professional correspondence and corporate mailing.",
      },
    ],
  },
  {
    number: "02",
    name: "Marketing & Signage",
    description:
      "Print solutions designed to make your brand, event or campaign impossible to miss.",
    imageClass: "marketing-image",
    items: [
      {
        item: "Flyers",
        detail:
          "High-quality single or double-sided flyers for promotions, events and campaigns.",
      },
      {
        item: "Posters",
        detail:
          "Large-format posters produced for events, retail displays and advertising.",
      },
      {
        item: "Banners",
        detail:
          "Durable vinyl banners suitable for indoor and outdoor promotional use.",
      },
      {
        item: "Signage",
        detail:
          "Custom signs and display graphics created for businesses, events and spaces.",
      },
    ],
  },
  {
    number: "03",
    name: "Books & Documents",
    description:
      "Reliable document production for businesses, institutions, schools and organizations.",
    imageClass: "documents-image",
    items: [
      {
        item: "Manuals",
        detail:
          "Clean, professionally printed manuals for training, operations and documentation.",
      },
      {
        item: "Thesis Binding",
        detail:
          "Professional academic binding with hardcover, lettering and finishing options.",
      },
      {
        item: "Booklets",
        detail:
          "Multi-page booklets for reports, programmes, brochures and publications.",
      },
      {
        item: "Bulk Printing",
        detail:
          "Cost-effective high-volume printing for large document and publishing runs.",
      },
    ],
  },
];

export default function Services() {
  return (
    <div className="services">

      {/* INTRO */}
      <section className="services-intro">
        <div className="wrap">
          <div className="services-intro-content">
            <span className="eyebrow">
              <span className="eyebrow-dot" />
              Our Services
            </span>

            <h1 className="services-title">
              Everything you need to
              <span> print with confidence.</span>
            </h1>

            <p className="services-lead">
              From everyday business stationery to large-format campaigns,
              we provide dependable printing solutions for businesses,
              organizations, events and individuals.
            </p>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="services-catalog">
        <div className="wrap">

          {groups.map((group) => (
            <article className="service-group" key={group.name}>

              {/* IMAGE / CATEGORY */}
              <div className="group-media-col">

                <div className={`group-image ${group.imageClass}`}>
                  <div className="image-overlay" />

                  <div className="group-number">
                    {group.number}
                  </div>

                  <span className="image-label">
                    IGC Print Press
                  </span>
                </div>

                <div className="group-heading">
                  <span className="group-kicker">
                    {group.number}
                  </span>

                  <div>
                    <h2 className="group-name">
                      {group.name}
                    </h2>

                    <p className="group-description">
                      {group.description}
                    </p>
                  </div>
                </div>

              </div>

              {/* SERVICES */}
              <div className="group-items-grid">

                {group.items.map((item, index) => (
                  <div className="service-item" key={item.item}>

                    <div className="service-item-top">
                      <span className="service-item-number">
                        {String(index + 1).padStart(2, "0")}
                      </span>

                      <span className="item-dot" />
                    </div>

                    <h3 className="service-item-title">
                      {item.item}
                    </h3>

                    <p className="service-item-detail">
                      {item.detail}
                    </p>

                  </div>
                ))}

              </div>

            </article>
          ))}

          {/* QUOTE CTA */}
          <div className="services-cta">

            <div className="services-cta-content">
              <span className="eyebrow">
                <span className="eyebrow-dot" />
                Start your project
              </span>

              <h2>
                Have something specific in mind?
              </h2>

              <p>
                Tell us what you need, the quantity and your preferred
                finishing. We'll help you figure out the best print option.
              </p>
            </div>

            <Link to="/quote" className="btn btn-primary services-cta-btn">
              Start a Print Job
              <span>→</span>
            </Link>

          </div>

          {/* WEBSITE BANNER */}
          <section className="services-web-banner">

            <div className="services-web-pattern services-web-pattern-one" />
            <div className="services-web-pattern services-web-pattern-two" />
            <div className="services-web-pattern services-web-pattern-three" />

            <div className="services-web-content">

              <span className="services-web-eyebrow">
                Beyond printing
              </span>

              <h2>
                Need a website for your business?
              </h2>

              <p>
                We can help you take your business online with a clean,
                professional website designed to make your brand stand out.
              </p>

              <Link
                to="https://cal.com/igcprintingpress/quick-chat"
                className="services-web-btn"
              >
                Schedule A Call
                <span>↗</span>
              </Link>

            </div>

            <div className="services-web-badge">
              <span>WEB</span>
              <strong>DESIGN</strong>
            </div>

          </section>

        </div>
      </section>

    </div>
  );
}